import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpInterceptorFn, HttpHandlerFn } from '@angular/common/http';
import { Observable, switchMap, take } from 'rxjs';
import { AuthService } from '../auth/services/auth.service';
import { environment } from '../../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (request: HttpRequest<any>, next: HttpHandlerFn) => {
  const authService = inject(AuthService);
  
  // Skip validation check for the validate-token endpoint
  if (request.url.includes('validate-token')) {
    return next(addToken(request));
  }

  return authService.isTokenValidated().pipe(
    take(1),
    switchMap(isValidated => {
      if (!isValidated) {
        return authService.validateToken().pipe(
          switchMap(() => next(addToken(request)))
        );
      }
      return next(addToken(request));
    })
  );
};

function addToken(request: HttpRequest<any>): HttpRequest<any> {
  const token = localStorage.getItem('token');
  const timezoneOffset = new Date().getTimezoneOffset();
  
  if (token) {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        'x-audience': environment.audience,
        'x-timezone-offset': timezoneOffset.toString()
      }
    });
  }
  return request.clone({
    setHeaders: {
      'x-audience': environment.audience,
      'x-timezone-offset': timezoneOffset.toString()
    }
  });
}

export const exportHeaderForXHttpRequest = (): Record<string, string> => {
  const token = localStorage.getItem('token');
  const timezoneOffset = new Date().getTimezoneOffset();
  return {
    Authorization: `Bearer ${token}`,
    'x-audience': environment.audience,
    'x-timezone-offset': timezoneOffset.toString()
  }
}